import {
  Bookmark,
  BookOpenCheck,
  IterationCcw,
  MapPin,
  PiggyBank,
} from "lucide-react";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

const StepOne = () => {
  return (
    <section className="flex flex-col gap-4" aria-label="Paso 1">
      <h1 className="text-3xl font-bold leading-tight text-foreground">
        ¡Bienvenido a Carriapp!
      </h1>
      <p className="text-muted-foreground leading-relaxed">
        En menos de 3 minutos descubriremos cuánto puedes ahorrar cada mes.
      </p>
      <Card className="gap-4">
        <CardHeader className="gap-2">
          <CardTitle>Vamos a: </CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col gap-4">
          <div className="flex gap-2">
            <MapPin className="text-primary" />
            <span className="text-sm">
              Encontrar los supermercados disponibles en tu zona
            </span>
          </div>
          <div className="flex gap-2">
            <Bookmark className="text-primary" />
            <span className="text-sm">
              Conectar tus membresías para exprimirlas aún más
            </span>
          </div>
          <div className="flex gap-2">
            <IterationCcw className="text-primary" />
            <span className="text-sm">Entender tu frecuencia de compra</span>
          </div>
          <div className="flex gap-2">
            <PiggyBank className="text-primary" />
            <span className="text-sm">Estimar tu potencial de ahorro</span>
          </div>
          <div className="flex gap-2">
            <BookOpenCheck className="text-primary" />
            <span className="text-sm">
              Crear tu primera lista, optimizarla y obtener tu ahorro
            </span>
          </div>
        </CardContent>
      </Card>
    </section>
  );
};

export default StepOne;
